var $de5691ae5c7dad55$exports = {};
$de5691ae5c7dad55$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$de5691ae5c7dad55$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
